import { isArray } from 'util';
import { mapCollection, sortByProperty } from '../../utils/collection.utils';
import { SaleOffer } from '../sale-offer';
import { SaleOfferLineBuilder } from './sale-offer-line-builder';
import { parseNumber } from '../../utils/number.utils';

export class SaleOfferBuilder {

  static fromJson(json): SaleOffer {
    return (json) ? new SaleOffer(
      json.hash,
      parseNumber(json.offerDate),
      json.customerHash,
      json.saleOrderHash,
      json.customerBusinessName,
      json.customerTradeName,
      json.traderHash,
      json.traderFirstName,
      json.traderLastName,
      parseNumber(json.offerNumber),
      json.observations,
      json.additionalData,
      json.internalObservations,
      json.offerObservations,
      json.paymentMethodHash,
      json.paymentMethodDescription,
      parseNumber(json.subTotalAmount),
      parseNumber(json.vat),
      parseNumber(json.totalVat),
      parseNumber(json.totalAmount),
      parseNumber(json.status),
      json.isPendingStepFinished,
      json.isInvoiceStepFinished,
      json.isDepartureStepFinished,
      json.isPreparationStepFinished,
      json.isPostageStepFinished,
      json.isControlDocumentStepFinished,
      json.sentByEmailDate,
      json.signedByCustomerDate,
      json.personWhoIsGoingToSign,
      json.saleOfferDepartureHash,
      json.saleOfferPreparationHash,
      json.saleOfferBearingHash,
      json.saleOfferControlDocumentHash,
      (isArray(json.saleOfferLines)) ? SaleOfferLineBuilder.fromJsonList(json.saleOfferLines) : [],
      json.isDeposit,
      json.saleOfferKeyCode
    ) : null;
  }

  static fromJsonList(list): SaleOffer[] {
    return (isArray(list)) ? sortByProperty('offerNumber', 'number', true, mapCollection(SaleOfferBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-builder.ts